import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const fetchProfile = () => axios.get(`${API}/profile`).then((r) => r.data);
export const fetchLinks = () => axios.get(`${API}/links`).then((r) => r.data);

export const trackClick = (id) => {
  const url = `${API}/links/${id}/click`;
  if (navigator.sendBeacon) return navigator.sendBeacon(url);
  axios.post(url).catch(() => {});
};
